import type {
  CampaignDeleteApiData,
  CampaignDeleteApiResponses,
  CampaignEndApiData,
  CampaignEndApiResponses,
  CampaignPatchApiData,
  CampaignPatchApiResponses
} from '@navio/nsdk';

import type { ApiInput } from '../../utils';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
import { campaignPatchFormData } from './campaignFormData';

export const patchCampaignMultipartEndpoint = responseEndpoint<
  CampaignPatchApiData,
  CampaignPatchApiResponses,
  ApiInput<CampaignPatchApiData> & { authCode?: string; image?: File | Blob | null }
>({
  getUrl: ({ campaignId }) => apiUrl(`campaigns/${campaignId}/`),
  getHeaders: () => ({
    'Content-Type': 'multipart/form-data'
  }),
  getBody: (data) => campaignPatchFormData(data),
  skipBodyTransformation: true
});

export const patchCampaignEndpoint = responseEndpoint<
  CampaignPatchApiData,
  CampaignPatchApiResponses,
  ApiInput<CampaignPatchApiData> & { authCode?: string; image?: File | Blob | null }
>({
  getUrl: ({ campaignId }) => apiUrl(`campaigns/${campaignId}/`),
  getBody: ({ campaignId: _campaignId, image: _image, authCode, ...body }) => ({
    ...body,
    ...(authCode != null ? { authCode } : {})
  })
});

export const deleteCampaignEndpoint = dataEndpoint<CampaignDeleteApiData, CampaignDeleteApiResponses>({
  getUrl: ({ campaignId }) => apiUrl(`campaigns/${campaignId}/`),
  getBody: ({ serviceOrganizationId }) => ({ serviceOrganizationId })
});

export const endCampaignEndpoint = dataEndpoint<CampaignEndApiData, CampaignEndApiResponses>({
  getUrl: ({ campaignId }) => apiUrl(`campaigns/${campaignId}/end/`),
  getBody: ({ serviceOrganizationId }) => ({ serviceOrganizationId })
});
